import { render, staticRenderFns } from "./WelfareMallStaffList.vue?vue&type=template&id=9055eae4&scoped=true"
import script from "./WelfareMallStaffList.vue?vue&type=script&lang=js"
export * from "./WelfareMallStaffList.vue?vue&type=script&lang=js"
import style0 from "./WelfareMallStaffList.vue?vue&type=style&index=0&id=9055eae4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9055eae4",
  null
  
)

export default component.exports